export const constants = {
  KnowMore: {
    aboutCoi: `<h4 style="color:'#000'">What is 'Colours of India'?</h4>
    <p>COI is a Decentralised Autonomous Organisation (DAO), set up by a group  of Indian NFT artists, for the benefit of Indian NFT artists, collectors and all members of the DAO.</p>
    <h4>Our Mission:</h4>
    <h5>We have a two-fold mission:</h5>
    <ol>
    <li>To serve as a platform for Indian art through empowering Indian artists  to enter the NFT space and by giving them a voice in the global art  community.</li>
    <li>To spread awareness about the decentralised creator economy and the  NFT space in India.</li>
    </ol>
    <h4>How are we going about this?</h4>
    <p>Our genesis community project is a collection of 1000 artworks by 1000  different artists that will be released as NFTs and minted on an  international marketplace. Through the course of this first project (and  beyond) the COI team will be educating artists about the NFT space,  promoting the initiative and individual artists (members of the DAO) on  international forums, including global rooms on Clubhouse, Twitter Spaces  and even through our own Colours of India podcast and youtube channel.  We will be running a campaign to get the initiative and its members  visibility in the mainstream media in India as well. All 1000 artworks will be  exhibited in a metaverse gallery for the global community to view.</p>
    <h4>How can I join the DAO? </h4>
    <p>For artists: There is an open call for all Indian artists (either citizens of  India or of Indian ethnicity) to submit a work of art they have created, as  part of their membership application. If selected by our panel of curators,  this artwork will be a part of COIs first project featuring 1000 Indian  artists. Each of these 1000 artists will receive a COI token, which is their  membership to the DAO. These tokens can be sold on the secondary  market, but to do so would mean you are relinquishing your membership 
    of the DAO to the new owner of the token. Every token equals one vote in  the DAO.</p>
    <p>For collectors: Upon collection of any of the 1000 pieces of art, the  collector will receive a COI token that will entitle them to membership.</p>
    <h4>What happens to the art I have submitted?</h4>
    <p>The artwork each artist submits will be attached to a COI token, which will  be anonymously sold to collectors. ie the collector will initially just receive  a COI token without knowing which artwork is attached to it. After all 1000  tokens are sold, the artwork attached to each token will be revealed in the  collector's wallet.</p>
    <p>Once all 1000 tokens are sold, the 1000 artists who have created the  works will receive an equal share of 90% of the gross revenue generated  by the sale. 10% will go into the wallet of the COI DAO.</p>
    <p>Revenue from secondary sales will go to the DAO for all its future projects  (as voted on by the members), some of which will include creating a COI  metaverse, an art fund to invest in interesting projects in the crypto space,  physical exhibitions and events for DAO members and a lot more.</p>
    `,
    metaconx: `<p>A 360-degree Web3 event that brings the community together to celebrate the emergence of a new era. From art to on-boarding, panel discussions to keynote addresses and meet and greet - MetaConX is a first of its kind art event set to take the Indian NFT and crypto community to the world and bring the world home to India.</p>`,
  },
  ArtGallery: [
    {
      imagePath: "img/art/image1.jpeg",
      alt: "art",
      heading: "Blue Warrior",
      knowMoreUrl: "",
      profilePic: "img/art/profile1.jpeg",
      name: "Angad",
      descrtiption:
        "The Blue Warrior is from a collection called ‘The Way of the Warrior’ by Angad B Sodhi. The series features Akali (The Immortal) Sikh warriors from the Punjab region of India in a Japanese Manga inspired style. The medium is a combination of photography, acrylic on canvas, procreate & photoshop. ",
      twitter: "https://www.twitter.com/angadbsodhi",
      instagram: "https://instagram.com/angadbsodhi",
    },
    {
      imagePath: "img/art/image2.mp4",
      alt: "art",
      heading: "Captured Fragility",
      knowMoreUrl: "",
      profilePic: "img/art/profile2.jpeg",
      name: "Ganesh Katave",
      twitter: "https://www.twitter.com/GANESHRK15/media",
      instagram: "https://www.instagram.com/ganeshkatwe/",
      description: `The beauty of fragile things is that they are in retrospect actually tough. A delicate flutter of a butterfly capable of creating a hurricane. Why then is that we capture fragility? Shying away and hiding all things delicate. But it's a risk worth taking as fragility cannot be captured.`,
    },
    {
      imagePath: "img/art/image3.jpeg",
      alt: "art",
      heading: "Plethora",
      knowMoreUrl: "",
      profilePic: "img/art/profile3.jpeg",
      name: "The Samosa Rani - Simran Wahan",
      twitter: "https://twitter.com/TheSamosaRani",
      instagram: "https://instagram.com/the.samosa.rani",
      description: `I'm putting together pieces of me,
      Nursing my wounds,
      Curing those scars,
      Finding a reason to be.
      I said to my body softly,
      ‘I want to be your friend.'
      I want to change the way you feel about pain.
      How sometimes broken things are beautiful.
      And sometimes you need a little ache to bloom.`,
    },
    {
      imagePath: "img/art/image4.jpeg",
      alt: "art",
      heading: "Sublimina",
      knowMoreUrl: "",
      profilePic: "img/art/profile4.jpeg",
      name: "Digipedia",
      twitter: "https://www.twitter.com/d3t3",
      instagram: "https://www.instagram.com/royalhalflitre",
      description: `Look through your inner eye,
      For what you cannot seek,
      Subliminal is the dye,
      That leaves a dark streak.`,
    },

    {
      imagePath: "img/art/image5.mp4",
      alt: "art",
      heading: "Dhyana - Mindfulness in Chaos",
      knowMoreUrl: "",
      profilePic: "img/art/profile5.jpeg",
      name: "RG",
      descrtiption: `Dhyana - Mindfulness in Chaos is a collaborative piece by Ramesh Gopal, Digital artists duo of Param Patel & Milindsinh Solanki, Digital Artist Harikrishnan S, music duo (Babyface Verse).
        Only once we accept that chaos is a part of life, we can attain “Dhyana”`,
      twitter: "https://twitter.com/Winbcblog1",
      instagram: "https://www.instagram.com/mikeblue7/",
    },
    {
      imagePath: "img/art/image6.jpeg",
      alt: "art",
      heading: "Kamini",
      knowMoreUrl: "",
      profilePic: "img/art/profile6.jpeg",
      name: "Shailpik",
      twitter: "https://twitter.com/shailpik",
      instagram: "https://instagram.com/shailpik",
      description: `Aparajita, The Undefeated
      Second mint in the Luminus collection on Foundation.`,
    },
    {
      imagePath: "img/art/image7.mp4",
      alt: "art",
      heading: "Sam",
      knowMoreUrl: "",
      profilePic: "img/art/profile7.jpeg",
      name: "Subha Sreenivasan Iyer",
      twitter: "https://twitter.com/IyerSubha",
      instagram: "https://www.instagram.com/subhasreenivasaniyer/",
      description: `Titled, "Sam" this artwork is a mixed-media portrait, and part of my series "Ladies Special". These are portraits of women, girls who were and are part of my life, people who inspired me through their actions, their way of life and stood for something larger than themselves. All of them are 1/1s.`,
    },
    {
      imagePath: "img/art/image8.mp4",
      alt: "art",
      heading: "Infinite Doors",
      knowMoreUrl: "",
      profilePic: "img/art/profile8.jpeg",
      name: "Rohan Ganapathy",
      twitter: "https://twitter.com/RohanGanapathy",
      instagram: "https://instagram.com/rohanganapathy",
      description: `Life offers us infinite doors.Every door I exit, I entered into a new one. Each door I entered into, births a new phase of life and learning. Everything in between me and the door is a journey.
      Every door opened helped in making me who I became.`,
    },

    {
      imagePath: "img/art/image9.mp4",
      alt: "art",
      heading: "Pixelated Vinscent (1/5)",
      knowMoreUrl: "",
      profilePic: "img/art/profile9.jpeg",
      name: "Pixelkar",
      descrtiption: `A Celebration of interaction with Master Vincent Van Gogh in my dreams and Influence of him on my Art life/ practice over the year
        It was as he Ignited the Turbulence in me.`,
      twitter: "https://twitter.com/Pixxelkar",
      instagram: "https://www.instagram.com/pixelkar/",
    },
    {
      imagePath: "img/art/image10.jpeg",
      alt: "art",
      heading: "Freedom Is Power",
      knowMoreUrl: "",
      profilePic: "img/art/profile10.jpeg",
      name: "Amoolya Bhat",
      twitter: "https://twitter.com/BhatAmoolya",
      instagram: "	https://www.instagram.com/amoolyabhat/",
      description: `"They thought they could cage us, afraid of the power that we possess." "My fire never goes out, I rise from my scars, Nothing hurts me now, 'Cause power is power, Now watch me burn it down."
      "Watch her animated form unfold by scanning her image on the app 'Artivive'"`,
    },
    {
      imagePath: "img/art/image11.jpeg",
      alt: "art",
      heading: "Blue-tailed Bee-Eater",
      knowMoreUrl: "",
      profilePic: "img/art/profile11.jpeg",
      name: "Mephentis",
      twitter: "https://twitter.com/@Dhrupad_280",
      instagram: "",
      description: `This is a photograph of the Blue- tailed Bee-eater taken in Bambolim, Goa. This photograph is part of a larger collection of photographs recording our planets fast disappearing biodiversity. More details about the photograph are available here :  
      https://www.inaturalist.org/observations/105619380`,
    },
  ],
  Blog: [
    {
      imagePath: "img/blog/image1.png",
      alt: "blog",
      heading: "BLue Galaxies in The Wind",
      knowMoreUrl: "",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo ",
      published: "09.08.2021",
    },
    {
      imagePath: "img/blog/image2.mp4",
      alt: "blog",
      heading: "BLue Galaxies in The Wind",
      knowMoreUrl: "",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo ",
      published: "09.08.2021",
    },
    {
      imagePath: "img/blog/image3.png",
      alt: "blog",
      heading: "BLue Galaxies in The Wind",
      knowMoreUrl: "",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo",
      published: "09.08.2021",
    },
    {
      imagePath: "img/blog/image1.png",
      alt: "blog",
      heading: "BLue Galaxies in The Wind",
      knowMoreUrl: "",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo ",
      published: "09.08.2021",
    },
    {
      imagePath: "img/blog/image2.png",
      alt: "blog",
      heading: "BLue Galaxies in The Wind",
      knowMoreUrl: "",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo ",
      published: "09.08.2021",
    },
    {
      imagePath: "img/blog/image3.png",
      alt: "blog",
      heading: "BLue Galaxies in The Wind",
      knowMoreUrl: "",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo",
      published: "09.08.2021",
    },
    {
      imagePath: "img/blog/image2.png",
      alt: "blog",
      heading: "BLue Galaxies in The Wind",
      knowMoreUrl: "",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo ",
      published: "09.08.2021",
    },
    {
      imagePath: "img/blog/image3.png",
      alt: "blog",
      heading: "BLue Galaxies in The Wind",
      knowMoreUrl: "",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo",
      published: "09.08.2021",
    },
  ],
  Faq: [
    {
      question: "question1",
      title: "How do I submit my work to Colours of India?",
      answer:
        "It is a simple, easy to understand five-step process. The video link is on the homepage.",
    },
    {
      question: "question2",
      title:
        "How is Colours of India different from any other community-driven initiative?",
      answer:
        "We are a group of individuals who have been active supporters of the NFT community, and we genuinely care about artists in India.",
    },
    {
      question: "question3",
      title: "Why is Colours of India doing this project?",
      answer:
        "We want to showcase the hidden gems of India to fine art and NFT collectors from all over the world",
    },
    {
      question: "question3",
      title: "When will I get to know that my work is selected?",
      answer:
        "After your submission, you will receive an email confirmation from us. You will also be notified a week before the artwork is minted. Don’t forget to check your promotional, social and junk emails too if you don’t see the email.",
    },
    {
      question: "question3",
      title:
        "Is it mandatory that I should have a crypto wallet before sending your application?",
      answer:
        "Yes, it is mandatory. Because we want the artist to send their applications and receive payment to their wallet directly. Kindly share your wallet address before signing in.",
    },
    {
      question: "question3",
      title: "What is minting? How does it work?",
      answer:
        "Minting is a process of listing your artworks on a block chain. This also includes a transaction fee. The transaction fees/gas fees vary in different platforms and it is totally depending on the blockchain. Generally, this is done by the artist. Since this is a community driven initiative, we will be doing it on behalf of the artist.",
    },
    {
      question: "question3",
      title: "Are you providing sale assurance after submitting my work?",
      answer: "No",
    },
    {
      question: "question3",
      title: "Am I allowed to burn my works if it didn’t sell?",
      answer: "Yes. You can send us an email after 6 months.",
    },
    {
      question: "question3",
      title: "How safe is to send my works to COI?",
      answer:
        "We can only assure that our team witl not share/copy your information without your consent. However, if something goes wrong on the block chain, your personal wallet or social media, we cannot be held responsible.",
    },
    {
      question: "question3",
      title: "Can I list multiple editions of my work?",
      answer:
        "No. Now we are collecting only 1/1 works. This is for the benefit of the collectors who would prefer rarity.",
    },

    {
      question: "question3",
      title: "What are the file formats accepted in the platform?",
      answer:
        "Video files as mp4 or WebM, image files as jpeg, png, gif are accepted.",
    },
    {
      question: "question3",
      title: "Is there an upper limit to the file size of an NFT?",
      answer: "Files up to a size of 500 MB can be added.",
    },
    {
      question: "question3",
      title: "How many artists can be a part of the colours of India project?",
      answer: "We are including. 1000 Indian artists on the 1st phase.",
    },
    {
      question: "question3",
      title: "Is it necessary that I must be a visual artist?",
      answer:
        "No, we include all forms of art. However. If you are submitting video files, Please ensure that you have the copyrights or an email confirmation from your collaborators.",
    },
    {
      question: "question3",
      title:
        "Can I send works which are unsold or already minted in other platforms?",
      answer: "No.",
    },
    {
      question: "question3",
      title:
        "Can I send works which are unsold or already exhibited in a gallery?",
      answer:
        "Yes. Provided your works are not listed on that gallery site or the art fairs anymore.",
    },
    {
      question: "question3",
      title: "How do COI Decide on the average price for the artworks?",
      answer: `After receiving all the applications, the community members will decide on the price. Before we list your artwork, you will get a confirmation mail from us, and you can let us know if you're okay to go ahead`,
    },
    {
      question: "question3",
      title: "On which platform are you planning to mint the artworks?",
      answer: "We will announce this  a week before the minting",
    },
    {
      question: "question3",
      title: "How do royalties work?",
      answer: "10 % from each sale goes to the COI project.",
    },
    {
      question: "question3",
      title: "Is it possible to share physical art pieces?",
      answer: `Yes. Indeed. However, the creator would have to deal with packaging, shipping, insurance, and other additional  processes at their own cost
        Each artwork will have a unique NFT id and with a serial number
        `,
    },
    {
      question: "question3",
      title: "Can I transfer my creator account to a new wallet?",
      answer: `No, we currently don't support account transfers to new wallets. The wallet address that is provided when setting up the user profile is unique and only the user has access to it, thereby maintaining proper authentication.`,
    },
    {
      question: "question3",
      title: "How safe is to send my works to COI?",
      answer:
        "We can only assure that our team witl not share/copy your information without your consent. However, if something goes wrong on the block chain, your personal wallet or social media, we cannot be held responsible.",
    },
    {
      question: "question3",
      title:
        "How and when does the collector know which artist work they have collected?",
      answer:
        "Once the 1000 pieces have been sold, we will be revealing the artworks (tbd)",
    },
    {
      question: "question3",
      title: "How can a collector buy NFTs?",
      answer: `Prerequisite: The buyer needs to have a Meta mask or any other wallet and it should be connected to the platform in which we are minting the works
        Step 1: Log in to the marketplace platform using your wallet ID
        Step 2: Click on 'Buy'
        Step 3: Confirm the transaction in your wallet.
        Step 4: Congratulations! You are now the proud owner of this mystery NFT.
        `,
    },
    {
      question: "question3",
      title: "Are there any fees for making purchases?",
      answer:
        "Yes. There will be a small transaction/gas fees associated with your NFT purchase.",
    },
    {
      question: "question3",
      title:
        "What are the benefits for artists after signing up for  COI project?",
      answer: `More visibility for artists in international marketplace.
        Artists will receive 90% of the sale
        All participating artists will be part of the first genesis pieces by COI project
        All participating artists will be part of the COI DAO
        `,
    },
    {
      question: "question3",
      title: "What are the utilities/benefits for collectors?",
      answer: `All collectors will be getting unique edition of 1/1 artworks from Indian artists.
        A single collage of all 1000 artworks will be sold in auction to the highest bidder. Please note that the collector will receive only the high res image of the collage work and not the individual artworks.
        The works will be very affordable compared to any other international platform. So it will be a great way to start your NFT collection.
        It is curated by experienced Indian NFT artists and collectors.
        Anyone who collects more than 10 tokens will receive a surprise gift from COI.
        Top 5 collectors will receive a surprise gift along with access to our DAO
        `,
    },
    {
      question: "question3",
      title: "Can I report an artwork or collectible?",
      answer: "Yes. Please reach out to us at hello@coloursofindianft.com",
    },
    {
      question: "question3",
      title: " How is COI contributing to the art community?",
      answer:
        "We are planning to tie up with art institutions and colleges to support the art infrastructure in India. ",
    },
    {
      question: "question3",
      title: "What percentage will COI take from the sale?",
      answer:
        "At the moment it is 10% E.g. If your work is sold for 100 USD, you will receive 90 USD worth of ETH in your wallet. The 10% will be used for the future development of COI.",
    },
    {
      question: "question3",
      title: "Can theatre practitioners send their performance videos?",
      answer:
        "You can send up to 3 original, unminted works as long as you hold all the rights or have explicit consent from all other rights holders of the art.",
    },
    {
      question: "question3",
      title: "Can the collector sell the artwork in the secondary market?",
      answer: "Yes. The secondary market will open after the reveal.",
    },
  ],
  Community: [
    { path: "img/community/image6.jpeg" },
    { path: "img/community/image7.jpeg" },
    { path: "img/community/image8.jpg" },
    { path: "img/community/image2.png" },
    { path: "img/community/image3.png" },
    { path: "img/community/image1.png" },
    { path: "img/community/image4.png" },
    { path: "img/community/image5.png" },
  ],
  Events: [
    { path: "img/events/image1.png" },
    { path: "img/events/image2.png" },
    { path: "img/events/image3.png" },
    { path: "img/events/image4.png" },
    { path: "img/events/image5.png" },
    { path: "img/events/image6.png" },
    { path: "img/events/image7.png" },
  ],
};
